import { BlocksSideMenuItem } from 'blocks-nextjs/blocks-web-components/components/side-menu-item/side-menu-item';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

/**
 * @deprecated - This component `CatSideMenuItem` has been deprecated and the updated version will be available with name `CatSideMenuItemLabs`. New component will be found under labs folder from Minor Release 3.10.0, `CatSideMenuItem` will be removed in 5.0 major release.
 */

export const CatSideMenuItem = createComponent({ react: React, tagName: 'cat-side-menu-item', elementClass: BlocksSideMenuItem });
